import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.LossCode.List.IRequest;
type Response = Api.Core.LossCode.List.IResponse;
type Headers = Api.Core.LossCode.List.IHeaders;
const url = '/api/Claims/LossCode';
export default async function lossCodeListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
